import * as api from './api';

const TABLE = 'supplier';
const PK = 'supplier_id';

export const fetchSuppliers = (searchTerm = '') =>
  api.fetchRecords(TABLE, {
    searchField: 'supplier_name',
    searchTerm,
  });

/** Supplier IDs are user-provided, so we keep the PK in the payload. */
export const createSupplier = (data) => {
  if (!data[PK]) throw new Error('Please provide a valid Supplier ID.');
  return api.createRecord(TABLE, data);
};

export const updateSupplier = (id, data) =>
  api.updateRecord(TABLE, PK, id, data);

export const deleteSupplier = (id) =>
  api.deleteRecord(TABLE, PK, id);
